/**
 * The most people an email to a whole list is offered for. Beyond that a mail
 * to everyone is rarely what is meant, and the link would grow towards the
 * length mail clients - Outlook on Windows above all - stop accepting.
 *
 * @public
 */
export const MAX_GROUP_MAIL_RECIPIENTS = 10;

/**
 * A `mailto:` link to all of the addresses at once, everyone in To so that a
 * reply reaches them all. No subject: that is up to whoever writes.
 *
 * @public
 */
export function groupMailUrl(addresses: string[]): string {
    return `mailto:${addresses.join(',')}`;
}
